import { render } from "./eldPage.vue?vue&type=template&id=147300c9&scoped=true"
import script from "./eldPage.vue?vue&type=script&lang=js"
export * from "./eldPage.vue?vue&type=script&lang=js"

import "./eldPage.vue?vue&type=style&index=0&id=147300c9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147300c9"]])

export default __exports__